"use strict";

(function (global) {

  /**
   * Массив с timestamp запросов.
   *
   * @private
   * @property _activeRequests
   * @since 5.6.0.9000
   */
  global.services._activeRequests = {};

  /**
   * Вызвать метод веб-сервисов.
   * В методы done и error можно передать функции обратного вызова,
   * которые выполняются тогда, когда будет получен ответ от сервиса.
   * Если операции веб-сервиса прошли без сбоев, то будет вызвана функция,
   * переданная в метод done данного deferred-объекта, иначе будет вызвана функция, переданная в метод еrror.
   * Полный ответ сервиса можно получить, обратившись к контексту this внутри функции callback.
   * @function WebAccess.services.request
   * @param {string} method Вызываемый метод веб-сервиса.
   * @param {object} [params] Параметры веб-сервиса (объект данных).
   * @param {object} [options = {}] Опции запроса.
   * @param {boolean} [options.sync = false] Признак синхронного запроса к серверу.
   * @param {boolean} [options.hideError = false] Признак отображения сообщения об ошибке.
   * @param {boolean} [options.hideWarning = false] Признак отображения предупреждения.
   * @param {boolean} [options.hideSpinner = false] Признак отображения анимации процесса загрузки.
   * @return {object} Deferred-объект – специальный объект для управления отложенными вызовами.
   * @this {object} result - результат выполнения сервиса содержит полный ответ.
   * @since 5.6.0.9054
   *
   * @example
   * WA.SRV.request('/Reference.asmx/CreateNewFilter', {
   *     ReferenceCode: WA.current.getReferenceCode(),
   *     Name: displayValue
   *   }).success(function (result) {
   *     console.log(result);  //то же самое что this.Result.
   *     console.log(this.Result);
   *     console.log(this.Warning);
   *     console.log(this.Success);
   *     console.log(this.Error);
   *   }).error(function(error) {
   *     console.log(error);
   *   });
   *
   * @example
   * WA.SRV.request('/Script.asmx/Run', {
   *     Name: 'WADemoTest',
   *     Params: { id: 10 }
   *   }, {
   *     sync: true,
   *     hideSpinner: true
   *   }).error(function(errorText) {
   *     ShowDialog(errorText);
   *   });
   */
  global.services.request = function (method, params = {}, options = {}) {
    return global.services._call(method, params, options);
  };

  /**
   * Вызвать метод веб-сервисов.
   * В методы done и error можно передать функции обратного вызова,
   * которые выполняются тогда, когда будет получен ответ от сервиса.
   * Если операции веб-сервиса прошли без сбоев, то будет вызвана функция,
   * переданная в метод done данного deferred-объекта, иначе будет вызвана функция, переданная в метод еrror.
   * Полный ответ сервиса можно получить обратившись к контексту this внутри функции callback.
   * @tutorial services
   * @function WebAccess.services.call
   * @param  {string}   service_method Вызываемый метод веб-сервиса.
   * @param  {object}   [opt_params] Параметры веб-сервиса.
   * @param  {string}   [opt_spinnerText] Текст строки прогресса.
   * @param  {string}   [opt_onCompleteSpinnerText] Текст строки прогресса после выполнения операции.
   * @param  {boolean}  [opt_hideError] Не отображать ошибку.
   * @param  {boolean}  [opt_hideWarning] Не отображать уведомления.
   * @return {Deferred} deferred-объект – специальный объект для управления отложенными вызовами.
   * @this {object} result - результат выполнения сервиса содержит полный ответ.
   * @since 5.0.0.4000
   * @deprecated since 5.6.0.9054. Use WebAccess.services.request instead
   *
   * @example
   * WA.SRV.call("/Reference.asmx/CreateNewFilter", { "ReferenceCode": WA.current.getReferenceCode(), "Name": displayValue }).success(function (result) {
   *   console.log(result);  //то же самое что this.Result.
       console.log(this.Result);
       console.log(this.Warning);
       console.log(this.Success);
       console.log(this.Error);
   * }).error(function(error) {
       console.log(error);
     });
   *
   * @example
   * WA.SRV.call("/Script.asmx/Run",{Name:"WADemoTest","Params": {"id": 10} }).error(function(errorText) { ShowDialog(errorText); } );
   */
  global.services.call = function (service_method, opt_params, opt_spinnerText, opt_onCompleteSpinnerText, opt_hideError, opt_hideWarning) {
    if (opt_spinnerText) console.log('Calling function WA.SRV.call() with deprecated parameter: opt_spinnerText');
    if (opt_onCompleteSpinnerText) console.log('Calling function WA.SRV.call() with deprecated parameter: opt_onCompleteSpinnerText');
    opt_params = opt_params || {};
    return global.services.request(service_method, opt_params, {
      sync: false,
      hideError: opt_hideError,
      hideWarning: opt_hideWarning,
    });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Выполнить синхронный вызов методов веб-сервисов.
   * В методы done и error можно передать функции обратного вызова,
   * которые выполняются тогда, когда будет получен ответ от сервиса.
   * Если операции веб-сервиса прошли без сбоев, то будет вызвана функция,
   * переданная в метод done данного deferred-объекта, иначе будет вызвана функция, переданная в метод еrror.
   *
   * @tutorial services
   * @function WebAccess.services.callSync
   * @param  {string}   service_method Вызываемый метод веб-сервиса.
   * @param  {object}   [opt_params] Параметры веб-сервиса.
   * @param  {string}   [opt_spinnerText] Текст строки прогресса.
   * @param  {string}   [opt_onCompleteSpinnerText] Текст строки прогресса после выполнения операции.
   * @param  {boolean}  [opt_hideError] Не отображать ошибку.
   * @param  {boolean}  [opt_hideWarning] Не отображать уведомления.
   * @return {Deferred} deferred-объект – специальный объект для управления отложенными вызовами.
   * @since 5.0.0.4004
   * @deprecated since 5.6.0.9054. Use WebAccess.services.request instead
   */
  global.services.callSync = function (service_method, opt_params, opt_spinnerText, opt_onCompleteSpinnerText, opt_hideError, opt_hideWarning) {
    window.log.info('You are using deprecated method WA.SRV.callSync(), use WA.SRV.request() with param { sync: true }');
    if (opt_spinnerText) console.log('Calling function WA.SRV.callSync() with deprecated parameter: opt_spinnerText');
    if (opt_onCompleteSpinnerText) console.log('Calling function WA.SRV.callSync() with deprecated parameter: opt_onCompleteSpinnerText');
    opt_params = opt_params || {};
    return global.services.request(service_method, opt_params, {
      sync: true,
      hideError: opt_hideError,
      hideWarning: opt_hideWarning,
    });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Вызов сервисов. Базовая функция.
   *
   * @method _call
   * @param {string} method Наименование метода.
   * @param {Object} params Параметры вызываемого метода.
   * @param {Object} options Опции.
   * @return {Deferred<Object>} Результат выполнения веб-метода.
   * @private
   * @see https://api.jquery.com/category/deferred-object/
   */
  global.services._call = function (method, params, options) {
    let deferred = $.Deferred();
    let requestId = + new Date();

    if (!method) {
      WA.raise('ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED', 'method');
    }

    deferred.success = deferred.done;
    deferred.error = deferred.fail;

    if (!options.hideSpinner && (!Object.keys(global.services._activeRequests).length || WA.CR.spinner && !WA.CR.spinner.isVisible)) {
      window.ShowSpinner();
    }
    global.services._activeRequests[requestId] = null;
    
    const xhr = $.ajax({
      type: 'POST',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      url: method,
      data: $.toJSON(params),
      async: !options.sync,
      cache: false,
      success: (res) => {
        if (!res) {
          deferred.rejectWith({}, ['NO_ANSWER']);
          return;
        }

        res = res.d;

        if (!options.hideWarning && res.Warning !== null) {
          window.ShowInlineHint(res.Warning, MESSAGE_TYPE.WARNING, INLINE_HINT_PRIORITY.PRIMARY);
        }

        if (!res.Success) {
          if (!options.hideError && res.Error) {
            let messageType = MESSAGE_TYPE.ERROR; 
            if (res.Severity && res.Severity !== '-1') {
              messageType = Number.parseInt(res.Severity);
            }            
            window.ShowInlineHint(res.Error, messageType, INLINE_HINT_PRIORITY.PRIMARY);            
          }
          deferred.rejectWith(res, [res.Error, res]);
        }

        if (window.CheckForLoginPage(res)) {
          return;
        }

        deferred.resolveWith(res, [res.Result, res]);
      },
      error: (err) => {
        let errorText = err.responseJSON ? err.responseJSON.Message : err.responseText;
        if (method.includes('/ClientStatistic.asmx/writeQueue')) {
          return;
        } else if (!global.services._isSessionAlive(err.status)) {
          errorText = L('WARN_BROKEN_SESSION');
        } else if ((!options.hideError) && (!global.services._sessionBrokenDialog)) {
          window.ShowInlineHint(errorText, MESSAGE_TYPE.ERROR, INLINE_HINT_PRIORITY.PRIMARY);
        }

        const errResp = Object.freeze({
          Result: null,
          Success: false,
          Warning: null,
          Error: errorText
        });
        deferred.rejectWith(errResp, [errorText, err]);
      },
      complete: () => {
        delete global.services._activeRequests[requestId];
        if (!Object.keys(global.services._activeRequests).length) {
          window.HideSpinner();
        }
      }
    });
    deferred.abort = xhr.abort;
    
    return deferred;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  global.services._sessionBrokenDialog = null;
  global.services._sessionRestoredDialog = null;

  /**
  * @fixme: рефактор плачет по этому
  * @private
  */
  global.services._isSessionAlive = function (statusCode) {

    if (statusCode == 401) {
      return false;
    }

    if (statusCode == 503) {
      WA.CR.inlineHint.show(L('ERROR_DESTRUCTIVE_FAULT'));
      log.error('SESSION', 'Service unavailavble');
      return false;
    }

    var dialog;
    if (statusCode == 475) {
      dialog = global.services._sessionRestoredDialog;
      if (!!dialog && dialog.isOpened()) {
        dialog.close();
      }

      if (!global.services._sessionBrokenDialog) {
        dialog = new WA.CMP.dialogs.MessageBox({ width: 450 });
        dialog.id = '475';
        dialog.isSingleInstance = true;
        dialog.removeDefaultButtons()
        .addButton('reloginLater', L('STAY_ON_PAGE'), function () {

        })
        .addButton('Relogin', L('LOGIN_AGAIN'), function () {
          ShowTopSpinner();
          WA.CR.window.openLogin();
        })
        .show(L('WARN_BROKEN_SESSION'), L('WARN_BROKEN_SESSION_DETAILS'), L('WARNING'), 'warning');
      } else {
        dialog = global.services._sessionBrokenDialog;
        dialog.show();
      }

      global.services._sessionBrokenDialog = dialog;
      return false;
    } else {
      dialog = global.services._sessionBrokenDialog;
      if (!!dialog && dialog.isOpened()) {
        dialog.close();
        if (!global.services._sessionRestoredDialog) {
          dialog = new WA.CMP.dialogs.MessageBox();
          dialog.isSingleInstance = true;
          dialog.removeDefaultButtons()
          .addButton('ReloginLater', L('OK'))
          .show(L('WARN_RESTORED_SESSION'), L('WARN_RESTORED_SESSION_DETAILS'), L('INFO'), 'info');

        }
      } else { dialog = global.services._sessionRestoredDialog }
      global.services._sessionRestoredDialog = dialog;
    }
    return true;
  };

  /**
   * Предоставляет инструменты для работы со справочниками, карточками справочников,
   * а также предоставляет ресурсы для выполнения различных настроек в справочниках, например, работа с фильтрами.
   *
   * @namespace WebAccess.services.reference
   * @since 5.0.0.4004
   */
  global.services.reference = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Предоставляет инструменты для работы со сценариями. Например, позволяет запустить сценарий.
   *
   * @namespace WebAccess.services.script
   * @since 5.0.0.4004
   */
  global.services.script = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Предоставляет инструменты для работы с объектами системы DIRECTUM.
   * Например, позволяет установить пользовательский статус на объекте.
   *
   * @namespace WebAccess.services.entity
   * @since 5.0.0.4200
   */
  global.services.entity = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Предоставляет инструменты для работы с задачами.
   * Например, позволяет создать задачу с вложениями и установить права на вложения задачи.
   *
   * @namespace WebAccess.services.task
   * @since 5.0.0.4200
   */
  global.services.task = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Предоставляет инструменты для проведения аутентификации пользователя и его работы с реквизитами.
   * Например, позволяет сменить пароль пользователя.
   *
   * @namespace WebAccess.services.authenticaion
   * @since 5.2.0.1200
   */
  global.services.authenticaion = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
 * Предоставляет инструменты для работы с папками системы DIRECTUM.
 * Например, позволяет установить пользовательские статусы на папках.
 *
 * @namespace WebAccess.services.folder
 * @since 5.0.0.4200
 */
  global.services.folder = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Предоставляет инструменты для работы с сессией пользователя.
   * Например, позволяет изменить тему профиля пользователя.
   *
   * @namespace WebAccess.services.session
   * @since 5.0.0.4214
   */
  global.services.session = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Предоставляет инструменты для работы с документами.
   *
   * @namespace WebAccess.services.document
   * @since 5.0.0.4218
   */
  global.services.document = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Предоставляет инструменты для работы с карточками.
   *
   * @namespace WebAccess.services.cardform
   * @since 5.0.0.7100
   */
  global.services.cardform = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Предоставляет инструменты для получения разметки реквизитов на сервере.
   *
   * @namespace WebAccess.services.requisite
   * @since 5.0.0.7100
   */
  global.services.requisite = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Предоставляет инструменты для работы с профилем пользователя.
   *
   * @namespace WebAccess.services.requisite
   * @since 5.6.0.1000
   */
  global.services.userProfile = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Предоставляет инструменты для работы со связями между объектами.
   *
   * @namespace WebAccess.services.relations
   * @since 5.6.0.1000
   */
  global.services.relations = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
})(window.WebAccess);
